import { Typography, useTheme } from '@mui/material'
import '@xyflow/react/dist/base.css'
import { IFlow } from '../../definitions/Nodes'
import { FlowEditorMode } from './SettlementFlowEditor'

interface P {
    mode: FlowEditorMode
    flow: IFlow
    children: JSX.Element | JSX.Element[]
}

function FlowBorderManager({ mode, flow, children }: P) {
    const theme = useTheme()
    const titleWidth = 100
    const isSubFlow = flow.type === 'sub-flow'

    // TODO implemet animation for run and dry-run

    const getModeColor = () => {
        const isSubFlow = flow?.type === 'sub-flow'

        switch (mode) {
            case 'edit': return isSubFlow ? theme.palette.subFlow.main : null
            case 'run': return theme.palette.primary.main
            case 'dry-run': return theme.palette.dryRun.main
            case 'compare':
            case 'audit': return theme.palette.audit.main
        }
    }

    const color = getModeColor()

    const getTitle = () => {
        switch (mode) {
            case 'edit': return isSubFlow ? 'Subflow' : null
            case 'run': return 'Run'
            case 'dry-run': return 'Dry run'
            case 'compare': return 'Compare'
            case 'audit': return 'Audit'
        }
    }

    return (
        <div style={{ height: '100%', width: '100%', position: 'relative', borderStyle: mode === 'compare' ? 'dashed' : 'solid', border: color && '4px solid ' + color }}>
            <div style={{ position: 'absolute', top: 0, left: `calc(50% - ${titleWidth / 2}px`, width: titleWidth, display: 'flex', justifyContent: 'center', backgroundColor: color, zIndex: 99, padding: theme.spacing(0.5), borderEndEndRadius: theme.spacing(1), borderEndStartRadius: theme.spacing(1) }}>
                <Typography variant='subtitle2'>{getTitle()}</Typography>
            </div>
            {children}
        </div>
    )
}

export default FlowBorderManager
